export function TabHeader({ title, gradient, subtextColor, subtext, iconButtons = [], actionButton = null }) {
  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
      {/* Subtext pill */}
      <div>
        {subtext && (
          <span style={{
            display: "inline-block",
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: subtextColor,
            background: `${subtextColor}18`,
            borderRadius: 99,
            padding: "2px 9px",
          }}>
            {subtext}
          </span>
        )}
      </div>
      {/* Right: icon buttons + action button */}
      <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
        {iconButtons.map((btn, i) => (
          <button key={i} onClick={btn.onClick} title={btn.title}
            style={{
              width: 32, height: 32, borderRadius: 10,
              border: `1.5px solid ${subtextColor}30`,
              background: `${subtextColor}10`,
              color: subtextColor,
              cursor: "pointer", display: "flex", alignItems: "center",
              justifyContent: "center", fontSize: 14, flexShrink: 0,
              transition: "all 0.15s",
            }}>
            {btn.icon}
          </button>
        ))}
        {actionButton && (
          <button onClick={actionButton.onClick} title={actionButton.title}
            style={{
              width: 32, height: 32, borderRadius: 10,
              border: `1.5px solid ${subtextColor}40`,
              background: `linear-gradient(135deg, ${subtextColor}18, ${subtextColor}30)`,
              color: subtextColor,
              cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center",
              boxShadow: `0 2px 8px ${subtextColor}25`,
              flexShrink: 0,
              transition: "transform 0.15s cubic-bezier(0.34,1.56,0.64,1)",
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.1)"; }}
            onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            {actionButton.icon}
          </button>
        )}
      </div>
    </div>
  );
}
